import React from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";

import { calculateSorting, SORTING_OPTIONS, DEFAULT_SORTING } from "./helpers/threadsSorting";
import { sortMenu, colorWildSand, colorAsphalt, colorUIBlack10, colorUIBlack20 } from "./styles/SortDropdownMenu.module.scss";

const SortDropdownMenu = ({ value, isLoading, onChange }) => {
  // Select uses styles for customization. See https://react-select.com/styles#style-object for more details.
  const styles = {
    control: (base, state) => ({
      ...base,
      background: colorWildSand,
      borderColor: state.isFocused ? colorUIBlack20 : colorWildSand,
      boxShadow: null,
      "&:hover": {
        background: colorUIBlack10
      }
    }),
    menu: base => ({ ...base, marginTop: 0 }),
    menuList: base => ({ ...base, padding: 0 }),
    singleValue: base => ({ ...base, color: colorAsphalt })
  };

  return (
    <Select
      styles={styles}
      className={sortMenu}
      defaultValue={calculateSorting(value)}
      value={calculateSorting(value)}
      options={SORTING_OPTIONS}
      onChange={onChange}
      isLoading={isLoading}
      isSearchable={false}
    />
  );
};

SortDropdownMenu.defaultProps = {
  isLoading: false
};

SortDropdownMenu.propTypes = {
  value: PropTypes.oneOf(SORTING_OPTIONS.map(option => option.value)),
  isLoading: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

export { DEFAULT_SORTING };

export default SortDropdownMenu;
